module.exports = __webpack_public_path__ + "media/images/footer/icon-arrow-7c803c1bd34f7b16a7a4388ac78f4ac9.svg";